import useSWR from 'swr';

import { IDetailResponse } from 'utils/types';

import { fetcher } from './utils';

export interface ITag {
  id: number;
  ratio_description?: string;
  image_width?: any;
  image_height?: any;
  image_section?: string;
}

export const useMediaTagList = () => {
  const url = '/v4/dash/simple/custom_image_ratios';

  const { data, isLoading } = useSWR<IDetailResponse<ITag[]>>({ url }, fetcher);

  return { data: data?.data, isLoading };
};
